export default __webpack_public_path__ + "static/media/Standard28.d38e4654.png";